<div class="text-center">
    <p> {{'lf_register_end_welcome_msg' | translate}} </p>
    <p *ngIf="products.length">{{'lf_register_end_msg' | translate}}</p>
</div>
<div class="from-top">
    <swiper class="swiper-container" fxFlex="auto" [config]="swipConfig" *ngIf="products?.length">
        <div class="swiper-slide my-3" *ngFor="let product of products">
            <!-- Title -->
            <div class="product-header py-4">
                <div class="product-active" *ngIf="product.isSubscribed">
                    {{ "gen_active" | translate}}
                </div>
                <h3>{{product.title}}</h3>
            </div>

            <div class="product-info py-4">
                <!-- Price -->
                <h3 class="display-4">
                    {{env.priceUnit + product.price}}
                </h3>

                <!-- Description -->
                <p class="p-3">{{product.description}}</p>

                <!-- Duration -->
                <p class="clr-sec-text" *ngIf="product.durationHours > 0 && env.features.packageDetails">
                    {{product.durationHours | durationCalc:'h'}}
                </p>

                <!-- Definition -->
                <div *ngIf="env.features.packageDetails">
                    <mat-divider></mat-divider>
                    <p class="pt-4">
                        {{'product_definition_msg' | translate}}</p>
                    <p class="clr-theme">{{product.definition.title}}</p>
                </div>

                <!-- Concurrency -->
                <div *ngIf="env.features.packageDetails">
                    <mat-divider></mat-divider>
                    <p class="pt-4">
                        {{('product_concurrency_msg' | translate)}}
                    </p>
                    <p class="clr-theme">{{product.concurrency}}</p>
                </div>

                <!-- Action Button -->
                <mat-divider></mat-divider>

                <!-- Subscribe Button -->
                <button class="button mt-4 mx-auto" (click)="subscribe(product)" *ngIf="!product.isSubscribed">
                    <i class="pr-1 fa fa-shopping-cart"></i>
                    {{ "gen_subscribe" | translate}}
                </button>

                <!-- Cancel Button -->
                <button class="button mt-4 mx-auto" (click)="cancelSubscription(product)"
                    *ngIf="product.isSubscribed && !product.cancelled">
                    <i class="pr-1 fa fa-user-slash"></i>
                    {{ "gen_cancel_subscription" | translate}}
                </button>

                <!-- Cancel Message -->
                <div class="p-3 mt-4 text-warning" *ngIf="product.isSubscribed && product.cancelled">
                    {{ "info_canceled_subscription" | translate}} {{product.expirationDate |
                    momentPipe:'DD/MM/YYYY'}}
                </div>
            </div>
        </div>
    </swiper>

    <div class="text-center w-100" *ngIf="!products?.length">
        <button class="button" (click)="startWatching()">
            {{'lf_register_end_btn' | translate}}
        </button>
    </div>
</div>